import { useState, SyntheticEvent } from 'react';

function usePaginationController() {
  const [currentPage, setCurrentPage] = useState(1);

  const onPageChange = (e: SyntheticEvent, newPage: number) => {
    setCurrentPage(newPage);
  };

  return {
    currentPage,
    onPageChange,
    setCurrentPage,
  };
}

export default usePaginationController;
